import { render, staticRenderFns } from "./MainNominados.vue?vue&type=template&id=4a321d80&"
import script from "./MainNominados.vue?vue&type=script&lang=js&"
export * from "./MainNominados.vue?vue&type=script&lang=js&"
import style0 from "./MainNominados.vue?vue&type=style&index=0&id=4a321d80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports